import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import "@fontsource/rubik/400.css";
import "@fontsource/montserrat/500.css";
import "@fontsource/montserrat/600.css";
import "@fontsource/montserrat/700.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import App from "./App";
import { ToastContainer } from "react-toastify";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import "@fontsource/rubik/400.css";
import "@fontsource/montserrat/500.css";
import "@fontsource/montserrat/600.css";
import "@fontsource/montserrat/700.css";

// Check if the browser supports Service Workers
if ("serviceWorker" in navigator) {
  window.addEventListener("load", async () => {
    const isProd = import.meta.env.VITE_APP_ENV === "production";
    const swPath = isProd
      ? "/firebase-messaging-sw.prod.js"
      : "/firebase-messaging-sw.stg.js";

    try {
      const registrations = await navigator.serviceWorker.getRegistrations();

      for (const reg of registrations) {
        if (!reg.active?.scriptURL?.includes(swPath)) {
          await reg.unregister();
        }
      }

      const reg = await navigator.serviceWorker.register(swPath, {
        updateViaCache: "none",
      });

      await reg.update();
    } catch (err) {
      console.error("[SW] Failed during registration/unregistration:", err);
    }
  });
}

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <GoogleReCaptchaProvider reCaptchaKey="6LfYmX4sAAAAAK3VgNFxFy3jmfH4FyWMuO9L-fs1">
    <BrowserRouter>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnFocusLoss
        pauseOnHover 
      />
        <App />
    </BrowserRouter>
  </GoogleReCaptchaProvider>
);
